import { render } from "./SelectTopKehus.vue?vue&type=template&id=1fb36080&scoped=true"
import script from "./SelectTopKehus.vue?vue&type=script&lang=js"
export * from "./SelectTopKehus.vue?vue&type=script&lang=js"

import "./SelectTopKehus.vue?vue&type=style&index=0&id=1fb36080&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb36080"]])

export default __exports__